export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site">
      <div className="wrap">
        <div className="foot-grid">
          <div className="wordmark">
            <div className="lock">
              <img
                src={`${process.env.PUBLIC_URL}/assets/praksi-logo-full.png`}
                alt="Φροντιστήριο Πράξη"
                id="brand-logo"
                width={200}
              />
            </div>
            <p className="blurb">
              Η γνώση γίνεται πράξη. Με μέθοδο, συνέπεια και αποτελέσματα, από
              το 2010 στη Μυτιλήνη.
            </p>
          </div>
          <div className="foot-col">
            <h4>Πλοήγηση</h4>
            <ul>
              <li>
                <a href="#about">Το φροντιστήριό μας</a>
              </li>
              <li>
                <a href="#why">Γιατί Πράξη</a>
              </li>
              <li>
                <a href="#stats">Επιτυχίες</a>
              </li>
              <li>
                <a href="#orient">Προσανατολισμός</a>
              </li>
              <li>
                <a href="#contact">Επικοινωνία</a>
              </li>
            </ul>
          </div>
          <div className="foot-col">
            <h4>Επικοινωνία</h4>
            <ul>
              <li>
                <a
                  href="https://maps.google.com/maps?q=%CE%9C%CF%85%CF%84%CE%B9%CE%BB%CE%AE%CE%BD%CE%B7%2C%20%CE%95%CF%81%CE%B5%CF%83%CF%83%CE%BF%CF%8D%2017"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ερεσσού 17, Μυτιλήνη
                </a>
              </li>
              <li>
                <a href="tel:+302251054070">22510 54070</a>
              </li>
              <li>
                <a href="mailto:info@praksi.gr">info@praksi.gr</a>
              </li>
              <li>Δευτ.–Παρ. 14:00–21:00</li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>
            © {year} Φροντιστήριο Πράξη. Με την επιφύλαξη παντός δικαιώματος.
          </span>
          <span>Μυτιλήνη · Λέσβος</span>
        </div>
      </div>
    </footer>
  );
}
